import React, {useState} from 'react';
import {makeStyles} from "@material-ui/core/styles";
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import Avatar from '@material-ui/core/Avatar';
import girl from "../../images/girl.png";
import man from "../../images/man.png";
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';

const useStyles = makeStyles((theme) => ({
  notesContainer: {
    maxHeight: 400,
    overflow: 'auto',
    backgroundColor: theme.palette.background.paper
  },
  avatar: {
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto',
    marginTop: theme.spacing(2)
  },
  time: {
    float: 'right'
  },
  note: {
    paddingRight: theme.spacing(2)
  },
  noteDivider: {
    width: '90%',
    display: 'block',
    marginLeft: 'auto',
    marginRight: 'auto'
  },
  sectionDivider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(2)
  },
  comment: {
    backgroundColor: theme.palette.background.paper
  },
  anonymousBtn: {
    marginLeft: theme.spacing(3)
  },
  saySomeThing: {
    marginTop: theme.spacing(2)
  },
  sex: {
    marginTop: theme.spacing(2)
  },
  submitBtn: {
    marginTop: theme.spacing(2),
    color: 'white',
    float: 'right'
  }
}));

const notes = [
  {
    id: 0,
    male: false,
    name: 'Lucia',
    time: '1 hour ago',
    content: 'This was not a battle you signed up for, but it is one for which you’re taking up arms and fighting regardless. '
  },
  {
    id: 1,
    male: true,
    name: 'Joe Cool',
    time: '4 days ago',
    content: 'I want you to know that I think you all are rockstars'
  },
];

export default function ThankyouNotes() {
  const classes = useStyles();
  const [currNotes, setCurrNotes] = useState(notes);
  const [name, setName] = useState();
  const [nameIsSecret, setNameIsSecret] = useState(false);
  const [comment, setComment] = useState();
  const [gender, setGender] = useState();

  const onClickSubmit = () => {
    const updateObject = {
      id: 2,
      male: gender === 'man',
      name: nameIsSecret ? 'Anonymous' : name,
      time: '1 min ago',
      content: comment
    };
    currNotes.unshift(updateObject);
    setCurrNotes(currNotes);

    setName(undefined);
    setComment(undefined);
    setGender(undefined);
    setNameIsSecret(false);
  };

  return (
    <div>
      <div className={classes.notesContainer}>
        {currNotes.map((note, index) => (
          <div key={note.id}>
            <Box p={2} m={2} borderRadius={6}>
              <Grid container spacing={2}>
                <Grid item xs={2}>
                  <Avatar className={classes.avatar}>
                    <img src={note.male ? man : girl} width="40" alt="Avatar"/>
                  </Avatar>
                </Grid>
                <Grid item xs>
                  <div className={classes.note}>
                    <div>
                      <Typography display={"inline"} color={"textPrimary"}><b>{note.name}</b></Typography>
                      <Typography display={"inline"} color={"textSecondary"} className={classes.time}>{note.time}</Typography>
                    </div>
                    <Typography>{note.content}</Typography>
                  </div>
                </Grid>
              </Grid>
            </Box>
            {index === notes.length - 1 ? null : <Divider className={classes.noteDivider} light/>}
          </div>
        ))}
      </div>
      {/*<Divider className={classes.sectionDivider}/>*/}
      <Box className={classes.comment} p={3} mt={4} borderRadius={6}>
        <TextField
          label="My name"
          variant="outlined"
          color="secondary"
          value={name ? nameIsSecret ? '' : name : ''}
          onChange={(e) => setName(e.target.value)}
          size={"small"}
          disabled={nameIsSecret}
        />
        <FormControlLabel
          control={<Checkbox checked={nameIsSecret} onChange={() => setNameIsSecret(!nameIsSecret)} />}
          label="Keep it secret"
          className={classes.anonymousBtn}
        />
        <TextField
          multiline
          fullWidth
          label="I also wanna say thank you"
          variant="outlined"
          color="secondary"
          size={"small"}
          value={comment ? comment : ''}
          onChange={(e) => setComment(e.target.value)}
          className={classes.saySomeThing}
        />
        <div>
          <FormControl className={classes.sex}>
            <RadioGroup row onChange={(e) => setGender(e.target.value)} value={gender ? gender : ''}>
              <FormControlLabel value="girl" control={<Radio />} label={<img src={girl} width="40" alt="Girl"/>} />
              <FormControlLabel value="man" control={<Radio />} label={<img src={man} width="40" alt="Man"/>} />
            </RadioGroup>
          </FormControl>
          <Button variant="contained" color="secondary" className={classes.submitBtn} onClick={onClickSubmit} disabled={comment == null}>
            Submit
          </Button>
        </div>
      </Box>
    </div>
  );
}
